import api from 'api';
import storage from "@/cflow/storageService";

class FaturaService {

    listar(dados, skip) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.post('/fatura?skip='+skip+'&token='+user.token, dados).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    opcoesFiltro() {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.get('/fatura?token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

}
export default new FaturaService();